import type { GroupMember, ProductGroupMember } from '../../../../infrastructure/ProductGroupClient';
import { isGroupMember, isProductMember } from '../../../../infrastructure/ProductGroupClient';

export interface ProductGroupSchema {
  memberAttribute: string;
  members: ProductGroupMember[];
}

export function collectLeafSkus(members: ProductGroupMember[]): string[] {
  const skus: string[] = [];
  members.forEach((member) => {
    if (isProductMember(member)) skus.push(member.sku);
    else if (isGroupMember(member)) skus.push(...collectLeafSkus(member.members));
  });

  return skus;
}

export function collectAttributePath(schema: ProductGroupSchema): string[] {
  const attributes: string[] = [schema.memberAttribute];
  let cursor: ProductGroupMember[] | undefined = schema.members;
  while (cursor && cursor.length > 0) {
    const firstBranch: GroupMember | undefined = cursor.find(isGroupMember);
    if (!firstBranch) break;
    attributes.push(firstBranch.memberAttribute);
    cursor = firstBranch.members;
  }

  return attributes;
}
